import React from 'react';
import ScrollingText from '../../../shared/components/ScrollingText';

const Keyword = ({text, number, riskLevel, expanded = false}) => {
  return (
    <div className={`keyword keyword--${riskLevel}${expanded ? ' keyword--expanded' : ''}`}>
      <span className={`keyword__text${expanded ? ' keyword__text--expanded' : ''}`}>
        {expanded ? text : <ScrollingText text={text} />}
      </span>
      <span className={`keyword__count keyword__count--${riskLevel}`}>
        {number}
      </span>
    </div>
  );
}

export default Keyword;
